import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SLINKY } from 'HubStyleTokens/colors';
import UIInputStaticLabel from 'UIComponents/input/UIInputStaticLabel';
import UITextInput from 'UIComponents/input/UITextInput';
import EPDeviceSelectButton from 'editor-components/preview/EPDeviceSelectButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const INPUT_WIDTH = '75px';
const INPUT_HEIGHT = '34px';
const BreakpointWrapper = styled.div.withConfig({
  displayName: "EPBreakpointControls__BreakpointWrapper",
  componentId: "sc-1vr3es8-0"
})(["position:relative;height:", ";"], INPUT_HEIGHT);
const PreviewWidthWrapper = styled.div.withConfig({
  displayName: "EPBreakpointControls__PreviewWidthWrapper",
  componentId: "sc-1vr3es8-1"
})(["position:absolute;display:inline-flex;height:", ";.ep-breakpoint-preview-width-label{color:", ";align-self:center;}.ep-breakpoint-preview-width-input{width:", ";height:", ";margin-top:3px;}"], INPUT_HEIGHT, SLINKY, INPUT_WIDTH, INPUT_HEIGHT);
const EPBreakpointControls = ({
  breakpoints,
  buttonClassName = 'p-y-2',
  buttonSize = 'medium',
  className = '',
  deviceSelectClassName = '',
  inputLabelClassName = 'm-left-2',
  inputLabelText = 'W',
  inputLabelWrapperClassName = '',
  onBreakpointSelect,
  previewWidth
}) => {
  if (!breakpoints || breakpoints.length === 0) {
    return null;
  }
  function handleBreakpointSelect(e) {
    if (onBreakpointSelect) {
      onBreakpointSelect(e);
    }
  }
  return /*#__PURE__*/_jsxs(BreakpointWrapper, {
    className: className,
    children: [/*#__PURE__*/_jsx(EPDeviceSelectButton, {
      buttonClassName: buttonClassName,
      buttonSize: buttonSize,
      className: deviceSelectClassName,
      defaultValue: typeof breakpoints[0] === 'object' ? breakpoints[0].name : breakpoints[0],
      devices: breakpoints,
      onChange: handleBreakpointSelect
    }), previewWidth && /*#__PURE__*/_jsx(PreviewWidthWrapper, {
      children: /*#__PURE__*/_jsx(UIInputStaticLabel, {
        className: `ep-breakpoint-preview-width-label ${inputLabelClassName}`,
        labelWrapperClassName: inputLabelWrapperClassName,
        text: inputLabelText,
        children: /*#__PURE__*/_jsx(UITextInput, {
          readOnly: true,
          className: "ep-breakpoint-preview-width-input",
          value: previewWidth
        })
      })
    })]
  });
};
EPBreakpointControls.propTypes = {
  breakpoints: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    name: PropTypes.string.isRequired,
    tooltip: PropTypes.node,
    icon: PropTypes.string
  }), PropTypes.string])).isRequired,
  buttonClassName: PropTypes.string,
  buttonSize: PropTypes.string,
  className: PropTypes.string,
  deviceSelectClassName: PropTypes.string,
  inputLabelClassName: PropTypes.string,
  inputLabelText: PropTypes.node,
  inputLabelWrapperClassName: PropTypes.string,
  showBreakpointWidthField: PropTypes.bool,
  onBreakpointSelect: PropTypes.func,
  previewWidth: PropTypes.string
};
export default EPBreakpointControls;